
const clients = [
    { id: 'example', name: 'Maria Johnson', program: 'Strength Training', status: 'Active', joinDate: '2023-03-15' },
    { id: 'client2', name: 'John Smith', program: 'Weight Loss', status: 'Active', joinDate: '2023-05-22' },
    { id: 'client3', name: 'Sarah Williams', program: 'Bodybuilding', status: 'Active', joinDate: '2023-01-10' },
    { id: 'client4', name: 'Michael Brown', program: 'Rehabilitation', status: 'On Hold', joinDate: '2022-11-05' },
    { id: 'client5', name: 'Emma Wilson', program: 'Endurance Training', status: 'Active', joinDate: '2023-06-18' },
    { id: 'client6', name: 'David Lee', program: 'Sport Specific', status: 'Completed', joinDate: '2022-08-30' },
    { id: 'client7', name: 'Jessica Martinez', program: 'Fitness Maintenance', status: 'Active', joinDate: '2023-04-12' },
    { id: 'client8', name: 'Robert Garcia', program: 'Muscle Building', status: 'Inactive', joinDate: '2022-09-15' },
  ];

export default clients;